/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { accessAPI, readFromLS, formatFecha } from "../../shared";

import { Card } from "primereact/card";
import { Skeleton } from "primereact/skeleton";

export default function AuditoriasSGAbiertas() {
  const [auditorias, setAuditorias] = useState();
  const [loading, setLoading] = useState(true);
  const [mostrar, setMostrar] = useState(false);

  useEffect(() => {
    let intentos = 0;
    const maxIntentos = 10;
    const intervalo = 300;

    const cargarAuditorias = () => {
      const token = readFromLS(process.env.REACT_APP_LS_LOGIN_TOKEN);

      if (!token) {
        if (intentos < maxIntentos) {
          intentos++;
          setTimeout(cargarAuditorias, intervalo);
        } else {
          setLoading(false);
        }
        return;
      }

      accessAPI(
        "GET",
        "auditorsg/auditoria",
        null,
        (respuesta) => {
          if (respuesta && respuesta.length > 0) {
            setAuditorias(respuesta);
            setMostrar(true);
          }
          setLoading(false);
        },
        (respuesta) => {
          // No mostrar nada si hay error (401, 403, etc.)
          setLoading(false);
        },
      );
    };

    cargarAuditorias();
  }, []);

  // No renderizar nada si no hay datos para mostrar
  if (!mostrar && !loading) {
    return null;
  }

  // Mostrar skeleton mientras carga
  if (loading) {
    return (
      <>
        <Skeleton
          width="22em"
          height="2.1em"
          css={{ marginBottom: "1.1em", marginTop: "1em" }}
        />
        <div className="grid">
          {[1, 2, 3].map((i) => (
            <div className="col-12 md:col-6 lg:col-4" key={i}>
              <Card css={{ textAlign: "center", minHeight: "100px" }}>
                <Skeleton
                  width="80%"
                  height="1.5em"
                  css={{ margin: "0 auto 1.5em auto" }}
                />
                <Skeleton width="60%" height="1em" css={{ margin: "0 auto" }} />
              </Card>
            </div>
          ))}
        </div>
      </>
    );
  }

  return (
    <>
      <h2>Auditorías del Sistema de Gestión</h2>
      <div className="grid">
        {auditorias &&
          auditorias.map((auditoria) => (
            <div className="col-12 md:col-6 lg:col-4" key={auditoria.id}>
              <Card
                css={{ textAlign: "center", cursor: "pointer" }}
                title={auditoria.nombre}
                onClick={(event) =>
                  window.open(
                    `/auditoriasg/${auditoria.id}`,
                    event.metaKey || event.ctrlKey ? "_blank" : "_self",
                  )
                }
              >
                <div>
                  <p>
                    Desde el{" "}
                    <strong>{formatFecha(auditoria.fechaInicio)} </strong>hasta{" "}
                    <strong>{formatFecha(auditoria.fechaFin)}</strong>
                  </p>
                </div>
              </Card>
            </div>
          ))}
      </div>
    </>
  );
}
